module.exports = __webpack_public_path__ + "img/monitores-descomplica.c48d67bc.svg";